import { SYMBOL_URL, CARD_TIERS } from "../data/content";

const tierAccent = (tier) => (CARD_TIERS.find((t) => t.name === tier) || {}).accent || "#8A8A93";

// A single collectable card face — used in the vault grid, reveal, and cart.
export const CollectableCard = ({ code = "—", tier = "Society", claimed = false, size = "md" }) => {
  const accent = tierAccent(tier);
  const pad = size === "sm" ? "p-2" : "p-4";
  return (
    <div
      className={`relative aspect-[3/4] w-full border ${pad} flex flex-col justify-between overflow-hidden`}
      style={{
        borderColor: claimed ? "#2A2A30" : accent,
        background: claimed
          ? "repeating-linear-gradient(45deg,#0d0d10,#0d0d10 6px,#0a0a0c 6px,#0a0a0c 12px)"
          : "radial-gradient(120% 90% at 50% 0%, #17171b 0%, #0a0a0c 70%)",
        opacity: claimed ? 0.55 : 1,
      }}
    >
      <div className="flex items-center justify-between">
        <span className="font-mono-bds text-[9px] uppercase tracking-[0.2em]" style={{ color: accent }}>
          {tier}
        </span>
        <span className="font-mono-bds text-[9px] text-bds-muted">BDS</span>
      </div>
      <img
        src={SYMBOL_URL}
        alt=""
        aria-hidden
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-2/3 object-contain mix-blend-screen"
        style={{ opacity: claimed ? 0.25 : 0.85 }}
      />
      <div className="relative">
        <p className="font-serif-display leading-none" style={{ fontSize: size === "sm" ? "1.25rem" : "2rem" }}>
          {code}
        </p>
        <p className="font-mono-bds text-[8px] uppercase tracking-[0.2em] text-bds-muted mt-1">/ 100</p>
      </div>
      {claimed && (
        <span className="absolute inset-0 grid place-items-center font-mono-bds text-[9px] uppercase tracking-[0.25em] text-bds-muted">
          Claimed
        </span>
      )}
    </div>
  );
};
